import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { toast } from "sonner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { api } from "../lib/api";
import { useSeo } from "../lib/seo";
import { RequestsPanel } from "../components/admin/RequestsPanel";
import { TestimonialsPanel } from "../components/admin/TestimonialsPanel";
import { PaymentsPanel } from "../components/admin/PaymentsPanel";
import { ResourcesPanel } from "../components/admin/ResourcesPanel";
import { FollowupEmailPanel } from "../components/admin/FollowupEmailPanel";
import { ResearchPanel } from "../components/admin/ResearchPanel";

export default function AdminDashboard() {
  useSeo("Owner dashboard");
  const nav = useNavigate();
  const [me, setMe] = useState(null);

  const logout = useCallback(() => {
    api.post("/auth/logout").catch(() => {}).finally(() => { localStorage.removeItem("dec_admin_token"); nav("/admin"); });
  }, [nav]);

  useEffect(() => {
    const g = new URLSearchParams(window.location.search).get("google");
    if (g === "connected") toast.success("Google Calendar connected");
    if (g === "error") toast.error("Google Calendar connection failed. Please try again.");
    api.get("/admin/settings").then(() => api.get("/auth/me", { headers: { Authorization: `Bearer ${localStorage.getItem("dec_admin_token")}` } }))
      .then((r) => setMe(r.data)).catch(logout);
  }, [logout]);

  if (!me) return <section className="bg-cream py-24 text-center font-sans text-slate">Checking your session...</section>;

  return (
    <section className="bg-cream text-ink py-14 md:py-20" data-testid="admin-dashboard">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="lbl text-teal">Owner dashboard</p>
            <h1 className="mt-3 !text-5xl">Your dashboard</h1>
          </div>
          <button onClick={logout} className="inline-flex items-center gap-2 font-sans border border-ink/40 rounded-full px-4 py-2 hover:bg-sky transition-colors" data-testid="admin-logout-button">
            <LogOut className="w-4 h-4" aria-hidden="true" /> Sign out
          </button>
        </div>
        <Tabs defaultValue="requests" className="mt-10">
          <TabsList className="bg-sky h-auto p-1 rounded-full flex-wrap font-sans">
            {[["requests", "Requests"], ["payments", "Payments"], ["resources", "Resources"], ["followup", "Follow-up email"], ["research", "Research"], ["testimonials", "Testimonials"]].map(([v, l]) => (
              <TabsTrigger key={v} value={v} className="rounded-full px-5 py-2 data-[state=active]:bg-teal data-[state=active]:text-paper" data-testid={`admin-tab-${v}`}>{l}</TabsTrigger>
            ))}
          </TabsList>
          <TabsContent value="requests" className="mt-8"><RequestsPanel /></TabsContent>
          <TabsContent value="payments" className="mt-8"><PaymentsPanel /></TabsContent>
          <TabsContent value="resources" className="mt-8"><ResourcesPanel /></TabsContent>
          <TabsContent value="followup" className="mt-8"><FollowupEmailPanel /></TabsContent>
          <TabsContent value="research" className="mt-8"><ResearchPanel /></TabsContent>
          <TabsContent value="testimonials" className="mt-8"><TestimonialsPanel /></TabsContent>
        </Tabs>
      </div>
    </section>
  );
}
